import type { Profile } from '../../lib/metrics'

/**
 * Rehber içerikleri.
 *
 * Bu listeler eskiden sabit metindi ve tek bir kişiye — panelin geliştiricisine —
 * göre yazılmıştı: 115 kg, salı/perşembe 20:30 tenis, cumartesi eşiyle yürüyüş.
 * Başka biri hesap açtığında panel ona başkasının haftasını gösteriyordu.
 *
 * Günlük liste artık profilden besleniyor (öğün saatleri kullanıcının kendi
 * saatleri). Mola listesi sabit ama kişisel varsayımlardan arındırıldı.
 *
 * Sabit "örnek hafta" tablosu tamamen silindi: haftalık şablonun gerçeği
 * Haftalık Program sekmesinde, kullanıcının kendi girdiği günlerde duruyor.
 * İki yerde iki farklı hafta göstermek, hangisinin doğru olduğunu soran bir
 * kullanıcı üretiyordu.
 */

const hhmm = (s: string) => (s ?? '').slice(0, 5)

export function checks(p: Profile): [string, string][] {
  const m1 = hhmm(p.meal1)
  const m2 = hhmm(p.meal2)
  return [
    [`1. öğün (${m1}) çorba/salata ile başladı`,
      'Ana tabaktan ÖNCE. Tek kural bu — uzun açlığın frenini burada çekiyorsun'],
    ['1. öğünde 2 avuç içi protein',
      '≈70 g. Günde 2 öğün yiyorsan her öğün protein açısından dolu olmak zorunda'],
    [`2. öğün (${m2}) da çorba/salata ile başladı`, 'Aynı kural, ikinci kez'],
    ['2. öğünde 2 avuç içi protein',
      'Akşam proteini kas koruma ve gece atıştırmasını kesme işini görüyor'],
    ['Karbonhidrat her öğünde 1 çukur avuçla sınırlı',
      '≈4–5 kaşık pilav/bulgur ya da 1 dilim ekmek'],
    ['Tabağı mutfakta doldurdum, ikinci porsiyon yok', 'Tencere/sofra kabı masaya gelmedi'],
    ['2.5 L su', 'Masadaki şişeyi 2–3 kez bitir'],
    ['7.000+ adım', 'Öğle yürüyüşü + akşam yürüyüşü'],
    ['Antrenman ya da spor (program günüyse)', 'Boş günse en az 30 dk yürüyüş'],
    ['Öğün penceresi dışında yemek yok',
      `${m1}–${m2} · spor günlerinde pencere otomatik kayıyor`],
  ]
}

/**
 * Mola görevleri. Sabit kalıyor — mola sayacı bunları arka planda, profil
 * elinde değilken de (bildirim metni için) okuyor. Bu yüzden hiçbiri kiloya
 * ya da kişiye bağlı değil; eskiden "115 kg'da ciddi bir set" yazıyordu.
 */
export const BREAKS: [string, string][] = [
  ['🚶 Evin içinde 3 tur at', 'Salon–mutfak–koridor. Amaç mesafe değil, kalçanın 5 dakika kapalı kalmaması.'],
  ['💧 Mutfağa git, şişeyi doldur', 'Hem su hem 40 adım. Günün en kolay iki kazancı aynı anda.'],
  ['🦵 20 sandalye squat', 'Oturup kalk, 20 kez. Ağırlık taşıyorsan bu ciddi bir set — bacaklarını uyandırır.'],
  ['🧍 Duvara yaslan, 60 sn göğüs esnetmesi', 'Kapı çerçevesine kollarını daya, öne uzan. Öne kapanan omuzların açılır.'],
  ['🪟 Balkona çık, 2 dk dur', 'Uzağa bak — gözünü de dinlendirir. Ekrandan tamamen kop.'],
  ['🧗 Merdiven varsa 2 tur in-çık', 'Apartmanda oturuyorsan en verimli mola bu.'],
  ['🙆 Boyun ve sırt esnetmesi', 'Kulağı omuza, 20 sn her yön. Sonra ellerini yukarı uzat, gerin.'],
  ['🧹 5 dakikalık bir ev işi', 'Bulaşık koy, çamaşır as. Hem hareket hem eve katkı.'],
  ['🚶 20 kalça köprüsü + 20 adım', 'Yere uzan, kalçanı kaldır. Oturmaktan uyuyan kaslar bunlar.'],
  ['☎️ Sonraki toplantıyı ayakta al', 'Kamerasızsa kulaklık tak ve yürü. Mola bitmesin, uzasın.'],
]
